import Vue from 'vue';
import Router from 'vue-router';
import ErrorPage from '@/components/ErrorPage';
import Mega from '@/components/MegaWidget';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/programme',
            alias: '/program',
            name: 'programme',
            component: Mega,
            props: { widget: 'program' },
        },
        {
            path: '/vue-generale',
            alias: '/general-view',
            name: 'general-view',
            component: Mega,
            props: {
                widget: 'digital-model',
                mode: 'general' 
            },
        },
        {
            path: '/maquette-3d',
            alias: '/digital-model',
            name: 'digital-model',
            component: Mega,
            props: {
                widget: 'digital-model',
                mode: 'digital-model'
            },
        },
        {
            path: '/plan-de-masse',
            alias: '/ground-plan',
            name: 'ground-plan',
            component: Mega,
            props: {
                widget: 'digital-model',
                mode: 'ground-plan',
            },
        },
        {
            path: '/vue-etages',
            alias: '/cutaway-view',
            name: 'cutaway-view',
            component: Mega,
            props: { widget: 'cutaway' },
        },
        {
            path: '/vue-drone',
            alias: '/drone-view',
            name: 'drone-view',
            component: Mega,
            props: { widget: 'drone-view' },
        },
        {
            path: '/vue-exterieure',
            alias: '/drone-floor-view',
            name: 'drone-floor-view',
            component: Mega,
            props: { widget: 'drone-floor-view' },
        },
        {
            path: '/visite-virtuelle',
            alias: '/virtual-tour',
            name: 'tour-model',
            component: Mega,
            props: { widget: 'virtual-tour' },
        },
        {
            path: '/lot',
            name: 'plot',
            component: Mega,
            props: { widget: 'plot' },
        },
        {
            path: '/plan-2d',
            alias: '/2d-plan',
            name: 'two-d-plan',
            component: Mega,
            props: { widget: '2d-plan' },
        },
        {
            path: '/plan-3d',
            alias: '/3d-plan',
            name: 'three-d-plan',
            component: Mega,
            props: { widget: '3d-plan' },
        },
        {
            path: '/animation',
            name: 'video',
            component: Mega,
            props: { widget: 'animation' },
        },
        {
            path: '/carrousel',
            alias: '/carousel',
            name: 'carousel',
            component: Mega,
            props: { widget: 'carousel' },
        },
        {
            path: '/carrousel-lot',
            alias: '/lot-carousel',
            name: 'plot-carousel',
            component: Mega,
            props: { widget: 'carousel-lot' },
        },
        {
            path: '/plan-de-quartier',
            alias: '/map',
            name: 'map',
            component: Mega,
            props: { widget: 'map-view' },
        },
        {
            path: '/visites-temoins',
            alias: '/virtual-tours',
            name: 'tour-models',
            component: Mega,
            props: { widget: 'models' },
        },
        {
            path: '/visites-configurables',
            alias: '/virtual-configurables-tours',
            name: 'conf-tour-models',
            component: Mega,
            props: { widget: 'conf-models' },
        },
        {
            path: '/perspective',
            name: 'perspective',
            component: Mega,
            props: { widget: 'perspective' },
        },
        {
            path: '/video-de-quartier',
            alias: '/district-video',
            name: 'district-video',
            component: Mega,
            props: { widget: 'district-video' },
        },
        {
            path: '/grille-de-lot',
            alias: '/plot-grid',
            name: 'plot-grid',
            component: Mega,
            props: { widget: 'plot-grid' },
        },
        {
            path: '/documents',
            name: 'documentation',
            component: Mega,
            props: { widget: 'documentation' },
        },
        {
            path: '/visite-configurable',
            alias: '/configurable-tour',
            name: 'configurable-tour',
            component: Mega,
            props: { widget: 'configurable-tour' },
        },
        {
            path: '/widget',
            name: 'one-for-all',
            component: Mega,
            props: {
                widget: 'one-for-all',
                mode: 'digital-model',
            },
        },
        {
            path: '/maquette-temps-reel',
            name: 'augmented-reality',
            component: Mega,
            props: {
                widget: 'augmented-reality',
                mode: 'general' 
            },
        },
        {
            path: '*',
            component: ErrorPage,
        },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js